<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Remitos</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item active">Argentina</li>
                  <li class="breadcrumb-item active">Administración</li>
                  <li class="breadcrumb-item active">Remitos</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <div class="card">
              <div class="card-header pt-2 pb-2">
                <div class="row justify-content-between">
                  <div class="btn-group">
                    <button
                      type="button"
                      class="btn bg-gradient-dark border-dark"
                      data-toggle="modal"
                      data-target="#modal-form-rank"
                      style="cursor: pointer"
                      v-if="$store.getters.can('argentina.remitos.create')"
                      @click="$refs.RemitoRangos.limpiarForm()"
                    >
                      Rangos de Remitos
                      <i class="fab fa-hackerrank"></i>
                    </button>
                  </div>
                  <div class="btn-group">
                    <button
                      type="button"
                      class="btn bg-gradient-info border-info"
                      @click="getIndex(), getGrafica()"
                    >
                      <i class="fas fa-sync-alt"></i>
                    </button>
                    <button
                      type="button"
                      class="btn bg-gradient-danger border-danger"
                      @click="resetFilter(), getGrafica()"
                    >
                      <i class="fas fa-broom"></i>
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary"
                      data-toggle="modal"
                      data-target="#modal-remito_individual"
                      style="cursor: pointer"
                      @click="$refs.RemitoIndividual.resetForm()"
                      v-if="$store.getters.can('argentina.remitos.create')"
                    >
                      <i class="fas fa-plus"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="card-body pb-2">
                <div class="row justify-content-center">
                  <div class="form-group col-md-3">
                    <label>Número de Remito</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      v-model="filtros.numero"
                      @keyup="getIndex(), getGrafica()"
                    />
                  </div>
                  <div class="form-group col-md-3">
                    <label>Fecha</label>
                    <input
                      type="date"
                      class="form-control form-control-sm"
                      v-model="filtros.fecha"
                      @input="getIndex(), getGrafica()"
                    />
                  </div>
                  <div class="form-group col-md-3">
                    <label>Tipo Empresa</label>
                    <select
                      class="form-control form-control-sm"
                      v-model="filtros.tipo_empresa"
                      @change="getIndex(), getGrafica()"
                    >
                      <option value>Seleccione...</option>
                      <option
                        v-for="tipoEmpresa in listasForms.tipoEmpresas"
                        :key="tipoEmpresa.numeracion"
                        :value="tipoEmpresa.numeracion"
                      >
                        {{ tipoEmpresa.descripcion }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group col-md-3">
                    <label>Estado</label>
                    <select
                      class="form-control form-control-sm"
                      v-model="filtros.estado"
                      @change="getIndex(), getGrafica()"
                    >
                      <option value>Seleccione...</option>
                      <option
                        v-for="estado in listasForms.estados"
                        :key="estado.numeracion"
                        :value="estado.numeracion"
                      >
                        {{ estado.descripcion }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="card-body table-responsive p-0">
                <table
                  id="remitos"
                  class="table table-bordered table-striped table-hover table-sm text-nowrap"
                  style="font-size: 0.85em"
                >
                  <thead class="bg-dark">
                    <tr>
                      <th>Número de Remito - DV</th>
                      <th>Fecha Ingreso</th>
                      <th>Tipo Empresa</th>
                      <th>Estado</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in remitos.data" :key="item.id">
                      <td>
                        {{ item.numero_formateado }}
                      </td>
                      <td class="text-center">
                        {{
                          item.created_at ? item.created_at.slice(0, 10) : ""
                        }}
                      </td>
                      <td>{{ item.tipoEmpresa }}</td>
                      <td class="text-center">
                        <div v-if="item.estado == 1">
                          <h6>
                            <span
                              class="badge badge-success"
                              data-toggle="modal"
                              data-target="#modal-form-estado"
                              @click="llenarModal(item.id, item.estado)"
                              style="cursor: pointer"
                            >
                              <i class="fas fa-check-circle"></i>
                              {{ item.estadoRemito }}
                            </span>
                          </h6>
                        </div>
                        <div v-else-if="item.estado == 2">
                          <h6>
                            <span class="badge badge-primary">
                              <i class="far fa-check-circle"></i>
                              {{ item.estadoRemito }}
                            </span>
                          </h6>
                        </div>
                        <div v-else-if="item.estado == 3">
                          <h6>
                            <span class="badge badge-warning">
                              <i class="fas fa-times-circle"></i>
                              {{ item.estadoRemito }}
                            </span>
                          </h6>
                        </div>
                        <div v-else>
                          <h6>
                            <span class="badge badge-danger">
                              <i class="far fa-times-circle"></i>
                              {{ item.estadoRemito }}
                            </span>
                          </h6>
                        </div>
                      </td>
                      <td class="text-right">
                        <div class="btn-group">
                          <button
                            class="btn btn-info"
                            v-if="$store.getters.can('argentina.remitos.show')"
                            @click="verRemito(item)"
                          >
                            <i class="fas fa-eye"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer">
                <div class="float-left" v-if="remitos.total">
                  Mostrando del
                  <b>{{ remitos.from }}</b> al <b>{{ remitos.to }}</b> de un
                  total: <b>{{ remitos.total }}</b> Registros
                </div>
                <div class="float-left" v-else>
                  <span class="badge badge-danger"
                    >No hay registros para mostrar</span
                  >
                </div>
                <pagination
                  :data="remitos"
                  @pagination-change-page="getIndex"
                  :limit="10"
                  class="float-right mb-0"
                ></pagination>
              </div>
            </div>
            <div class="col-md-12">
              <div class="row">
                <div class="col-lg-3">
                  <div class="small-box bg-secondary">
                    <div class="inner">
                      <h3 style="font-size: 3.5em">Remitos</h3>
                      <h3 style="font-size: 1.1em">
                        Disponibles:
                        <span
                          class="badge badge-pill badge-success float-right"
                        >
                          {{ cantidadDisp }}
                        </span>
                      </h3>
                      <h3 style="font-size: 1.1em">
                        Usados:
                        <span
                          class="badge badge-pill badge-primary float-right"
                        >
                          {{ cantidadUsa }}
                        </span>
                      </h3>
                      <h3 style="font-size: 1.1em">
                        Anulados:
                        <span
                          class="badge badge-pill badge-warning float-right"
                        >
                          {{ cantidadAnu }}
                        </span>
                      </h3>
                    </div>
                    <div class="icon">
                      <i class="ion ion-pie-graph"></i>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="small-box bg-light">
                    <pie-chart
                      :data="chartData"
                      :options="chartOptionsPie"
                    ></pie-chart>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <RemitoEstado ref="RemitoEstado" />
        <RemitoRangos ref="RemitoRangos" />
        <RemitoIndividual ref="RemitoIndividual" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import pagination from "laravel-vue-pagination";
import RemitoEstado from "./RemitoEstado";
import RemitoRangos from "./RemitoRangos";
import RemitoIndividual from "./RemitoIndividual";
import PieChart from "../../../hidrocarburos/administrativo/PieChart.js";
import Loading from "../../../../components/Loading";

export default {
  name: "Remitos",

  components: {
    Loading,
    pagination,
    RemitoEstado,
    RemitoRangos,
    RemitoIndividual,
    PieChart,
  },

  data() {
    return {
      chartOptionsPie: {
        hoverBorderWidth: 10,
      },
      animation: {
        animateRotate: false,
        animateScale: true,
      },
      chartData: {
        labels: ["Disponibles", "Usados", "Anulados"],
        datasets: [
          {
            backgroundColor: ["#00C851", "#0099CC", "#ffbb33"],
            borderWidth: 2,
          },
        ],
      },
      filtros: {},
      remitos: {},
      listasForms: {
        tipoEmpresas: [],
        estados: [],
      },
      cargando: false,
      cantidadDisp: "",
      cantidadUsa: "",
      cantidadAnu: "",
    };
  },

  methods: {
    getIndex(page = 1) {
      let me = this;
      me.cargando = true;

      axios
        .get("/api/argentina/remitos?page=" + page, {
          params: this.filtros,
        })
        .then(function(response) {
          me.cargando = false;
          me.remitos = response.data;
        })
        .catch(function(error) {
          me.cargando = false;
          console.error("Error al cargar remitos:", error);
        });
    },

    getTipoEmpresas() {
      axios.get("/api/lista/58").then((response) => {
        this.listasForms.tipoEmpresas = response.data;
      });
    },

    getEstados() {
      axios.get("/api/lista/37").then((response) => {
        this.listasForms.estados = response.data;
      });
    },

    resetFilter() {
      this.filtros = {};
      this.getIndex();
    },

    llenarModal(id, estado) {
      this.$refs.RemitoEstado.llenar_modal(id, estado);
    },

    verRemito(item) {
      // Navegar a vista de detalle si existe
      console.log("Ver remito:", item);
    },

    async getGrafica() {
      let me = this;

      await axios
        .get("/api/argentina/remitos/graficas", {
          params: this.filtros,
        })
        .then(async (response) => {
          let respuesta = response.data;
          me.cantidadDisp = respuesta.cantDisp || 0;
          me.cantidadUsa = respuesta.cantUsa || 0;
          me.cantidadAnu = respuesta.cantAnu || 0;

          // Data de gráfica de pie
          me.chartData.datasets[0].data[0] = me.cantidadDisp;
          me.chartData.datasets[0].data[1] = me.cantidadUsa;
          me.chartData.datasets[0].data[2] = me.cantidadAnu;
        })
        .catch(function(error) {
          console.error("Error al cargar gráficas:", error);
        });
    },
  },

  beforeMount() {
    this.getEstados();
    this.getTipoEmpresas();
  },

  mounted() {
    this.getIndex();
    this.getGrafica();
  },
};
</script>
